class SpinnerService {
	appendTo($element, isSmall) {
		if($element) {
			let elem = $element.find('.spinner-border');

			(elem.length === 0)
				&& $element.append(`<span class="spinner-border ${isSmall ? 'spinner-border-sm' : ''}"></span>`);
		}
	}

	removeFrom($element) {
		$element.find('.spinner-border').remove();
	}
}

export let spinnerService = new SpinnerService();



// WEBPACK FOOTER //
// ./spinnerService.js